import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FilterToggle from '../filters/filterToggle';
import TailwindMultipleUsersEditor from 'widgets/bussiness/multiple-selector/multiple-user-editor-tw';
import TailwindMultipleLocationEditor from 'widgets/bussiness/multiple-selector/multiple-location-editor-tw';
import { UserDto } from 'stores/users/users-store';
import { LocationDto } from 'stores/configuration/locations/locations-store';

interface CalendarHeaderProps {
  selectedFilterType: 'instructor' | 'location';
  entityType: 'events' | 'requests';
  isBusy?: boolean;
  onToggleFilterType?: (type: 'instructor' | 'location') => void;
  onChange?: (type: 'instructor' | 'location', filter: any) => void;
  locationList: any[];
  setLocationList: React.Dispatch<React.SetStateAction<any[]>>;
  instructorsNameList: any[];
  setInstructorsNameList: React.Dispatch<React.SetStateAction<any[]>>;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  selectedFilterType,
  entityType,
  isBusy,
  onChange,
  onToggleFilterType,
  locationList,
  setLocationList,
  instructorsNameList,
  setInstructorsNameList
}) => {
  const { t } = useTranslation();
  const [activeFilters, setActiveFilters] = useState<{ [key: string]: any }>({});
  //const [instructorsNameList, setInstructorsNameList] = useState<UserDto[]>([]);

  const handleLocationListFilterChange = (value: LocationDto[], fieldName: string) => {
    const activeFiltersCopy = { ...activeFilters };

    if (!value || value.length <= 0) {
      delete activeFiltersCopy[fieldName];
      setLocationList([]);
    } else {
      const filterValue = {};
      if (entityType === 'events') {
        filterValue['eventDetails/locationId'] = { in: { value: value.map(location => location.id), type: 'guid' } };
      } else {
        filterValue['requestingLocationId'] = { in: { value: value.map(location => location.id), type: 'guid' } };
      }
      activeFiltersCopy[fieldName] = filterValue;
    }
    setActiveFilters(activeFiltersCopy);
    setLocationList(value);
    onChange('location', activeFiltersCopy);
  };

  const onInstructorsListFilterChange = (value: UserDto[], fieldName: string) => {
    const activeFiltersCopy = { ...activeFilters };
    if (!value || value.length <= 0) {
      delete activeFiltersCopy[fieldName];
      setInstructorsNameList([]);
    } else {
      activeFiltersCopy[fieldName] = {
        eventInstructors: { any: [{ instructorId: { in: { type: 'guid', value: value.map(location => location.id) } } }] }
      };
    }

    setActiveFilters(activeFiltersCopy);
    setInstructorsNameList(value);
    onChange('instructor', activeFiltersCopy);
  };

  return (
    // <div className="flex justify-between items-center gap-4 px-4 py-4 border-b">
    <div className="p-4">
      <div className="mb-3">
        <label className="block text-sm text-gray-700 mb-1">{t('Filter by:')}</label>
        {selectedFilterType && selectedFilterType === 'instructor' && entityType === 'events' ? (
          <TailwindMultipleUsersEditor
            className="w-full p-2 border border-gray-300 rounded"
            placeholder={t('Instructor Name')}
            value={instructorsNameList}
            clearable
            onChange={value => onInstructorsListFilterChange(value, 'instructors')}
            role="Instructor"
            locationIds={[]}
            disabled={isBusy}
          />
        ) : (
          <TailwindMultipleLocationEditor
            className="w-full p-2 border border-gray-300 rounded"
            clearable
            placeholder={t(`${entityType === 'events' ? 'Event' : 'Request'} Location`)}
            value={locationList}
            onChange={value => handleLocationListFilterChange(value, 'eventLocation')}
            showCountry={true}
            disabled={isBusy}
          />
        )}
      </div>
      <FilterToggle
        selectedFilterType={selectedFilterType}
        onToggleFilterType={onToggleFilterType}
        disabled={isBusy}
        entityType={entityType}
      />
    </div>
  );
};

export default CalendarHeader;
